export const formatJobTime = (date, fallback = "Recently posted") => {
  if (!date) return fallback;

  const diffMilliseconds = new Date() - new Date(date);
  const diffHours = Math.max(Math.floor(diffMilliseconds / (1000 * 60 * 60)), 0);

  if (diffHours < 1) return "Just now";
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;

  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
};

export const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const formatSalary = (job) => {
  if (job?.salary_range) return job.salary_range;
  if (job?.salary_min && job?.salary_max) return `${job.salary_currency ?? "USD"} ${job.salary_min} - ${job.salary_max}`;
  if (job?.salary_min) return `From ${job.salary_currency ?? "USD"} ${job.salary_min}`;
  if (job?.salary_max) return `Up to ${job.salary_currency ?? "USD"} ${job.salary_max}`;

  return "Not disclosed";
};

export const mapApiJob = (job, options = {}) => {
  if (!job) return null;

  const status = job.effective_status ?? job.status;

  return {
    id: job.id,
    logo: job.company_logo_url ?? null,
    title: job.title ?? "Unavailable job",
    company: job.company_display_name ?? job.company_name ?? "Epic Jobs",
    companyProfileId: job.company_profile_id,
    location: job.location ?? "Location unavailable",
    time: options.time ?? formatJobTime(job.published_at ?? job.created_at),
    salary: formatSalary(job),
    type: job.job_type,
    workplaceType: job.workplace_type,
    category: job.category,
    experience: job.experience,
    vacancies: job.vacancies,
    isSaved: Boolean(job.is_saved),
    hasApplied: Boolean(job.has_applied),
    status,
    rawStatus: job.raw_status ?? job.status,
    isExpired: Boolean(job.is_expired),
    canApply: job.can_apply !== undefined ? Boolean(job.can_apply) : (job.status === "active" && !job.is_expired),
    tags: [
      job.job_type,
      job.workplace_type,
      job.category,
      job.is_urgent ? "Urgent" : null,
      job.is_featured ? "Featured" : null,
      status && status !== "active" ? status : null,
    ].filter(Boolean),
  };
};
